<div class="dealers layout-spacing" data-testid="dealers-dealers-div">
    @if (showForTM()) {
        <ng-template #subNavBarContent>
            <div class="dealers__actions" data-testid="dealers-dealers-actions-div">
                <ntv-button
                    class="dealers__analytics-btn"
                    [variant]="'accent'"
                    [fullWidth]="true"
                    [size]="'xl'"
                    (buttonClick)="toggleAnalytics()"
                    data-testid="show-analytics-btn">
                    <div
                        class="dealers__analytics-btn-content"
                        data-testid="dealers-dealers-analytics-btn-content-div">
                        <div
                            class="dealers__analytics-btn-label"
                            data-testid="dealers-dealers-analytics-btn-label-div">
                            <svg width="14" height="14">
                                <use [attr.href]="spritePath + '#' + icons.reports"></use>
                            </svg>
                            <span>{{ showAnalytics() ? 'Hide Analytics' : 'Show Analytics' }}</span>
                        </div>

                        <svg
                            class="dealers__analytics-btn-chevron"
                            [class.dealers__analytics-btn-chevron--open]="showAnalytics()"
                            width="12"
                            height="12">
                            <use [attr.href]="spritePath + '#' + icons.chevronDown"></use>
                        </svg>
                    </div>
                </ntv-button>
            </div>
        </ng-template>
    }
    <div class="dealers__stats" data-testid="dealers-dealers-stats-div">
        @if (shouldShowAnalyticsSkeleton()) {
            @for (index of [1, 2, 3]; track $index) {
                <app-stats-card [isLoading]="true" [hasTotal]="true" width="100%" />
            }
        } @else {
            @for (dealer of statsData(); track dealer.title + $index) {
                <app-stats-card [statsData]="dealer" [hasTotal]="true" width="100%" height="100%" />
            }
        }
    </div>

    <div
        class="dealers__analytics"
        [class.dealers__analytics--visible]="showAnalytics()"
        data-testid="dealers-analytics-panel">
        <div class="dealers__analytics-inner" data-testid="dealers-analytics-inner-div">
            <div class="dealers__analytics-graph" data-testid="dealers-analytics-graph-wrapper">
                @if (shouldShowAnalyticsSkeleton()) {
                    <ntv-card
                        variant="elevated"
                        class="dealers__analytics-card"
                        data-testid="dealers-analytics-setup-card">
                        <div
                            class="analytics-graph-content bg-transparent"
                            data-testid="dealers-analytics-graph-content-div">
                            <ntv-skeleton
                                width="100%"
                                height="300px"
                                borderRadius="12px"
                                data-testid="dealers-analytics-setup-skeleton" />
                        </div>
                    </ntv-card>
                    <ntv-card
                        variant="elevated"
                        class="dealers__analytics-card"
                        data-testid="dealers-analytics-risk-card">
                        <div
                            class="analytics-graph-content bg-transparent"
                            data-testid="dealers-analytics-graph-content-div-2">
                            <ntv-skeleton
                                width="100%"
                                height="300px"
                                borderRadius="12px"
                                data-testid="dealers-analytics-risk-skeleton" />
                        </div>
                    </ntv-card>
                } @else {
                    <ntv-card variant="elevated" data-testid="dealers-analytics-setup-card">
                        <ntv-graph
                            [config]="dealerSetupData()"
                            data-testid="dealers-analytics-setup-graph"></ntv-graph>
                    </ntv-card>
                    <ntv-card variant="elevated" data-testid="dealers-analytics-risk-card">
                        <ntv-graph
                            [config]="riskStatusData()"
                            data-testid="dealers-analytics-risk-graph"></ntv-graph>
                    </ntv-card>
                }
            </div>
        </div>
    </div>

    <div class="dealers__table" data-testid="dealers-dealers-table-div">
        <app-table-toolbar
            [placeholder]="'Search by dealer alias or business name'"
            [buttons]="toolbarButtons()"
            (searchValueChange)="searchTerm.set($event)"
            (actionClick)="onToolbarAction($event)">
            @if (showForTM()) {
                <app-filter-dropdown
                    leftActions
                    type="grouped"
                    [groupedOptions]="filterOptions()"
                    (groupedOptionsChanged)="onFilterOptionClick($event)">
                </app-filter-dropdown>
            }
        </app-table-toolbar>

        <div
            class="dealers__table-content main-table-container"
            data-testid="dealers-dealers-table-content-div">
            <app-table
                [columns]="dealerTableColumns"
                [data]="dealerData()"
                [loading]="isLoading() || (tableLoading() && !loadingMore())"
                [loadingOverlay]="loadingMore()"
                tableTitle="Dealers"
                [totalDataLength]="dealerTotalCount()"
                [hasCheckBox]="false"
                [tableHeight]="'auto'"
                [pageSize]="pageSize"
                (actionClick)="onActionClick($event)"
                [showColumnSettings]="false"
                (showMoreRequested)="loadMoreDealers()"
                (showLessRequested)="onShowLess()"
                (cellClick)="onCellClick($event)"
                (selectionChange)="onSelectionChange($event)">
                <ng-template #expandedContent let-rowData>
                    <div class="p-4 bg-gray-50 border-t border-gray-200">
                        <div class="flex items-center justify-between gap-4 mb-3">
                            <div>
                                <p class="text-sm font-semibold text-gray-800">
                                    {{ rowData.dealerAlias }} details
                                </p>
                                <p class="text-xs text-gray-500">{{ rowData.businessName }}</p>
                            </div>
                            <span class="text-xs font-medium text-gray-600">
                                Status: {{ rowData.status }}
                            </span>
                        </div>

                        <div class="grid grid-cols-2 gap-3 text-xs text-gray-700 md:grid-cols-4">
                            <div><strong>Contact:</strong> {{ rowData.contactPerson }}</div>
                            <div><strong>Age:</strong> {{ rowData.age }}</div>
                            <div><strong>Schedule:</strong> {{ rowData.schedule }}</div>
                            <div><strong>License:</strong> {{ rowData.licenseKey }}</div>
                        </div>
                    </div>
                </ng-template>
            </app-table>
        </div>
    </div>
</div>

@if (showDeleteConfirmationModal()) {
    <app-confirmation-modal
        [isVisible]="showDeleteConfirmationModal()"
        [showCancelButton]="true"
        [loopAnimation]="false"
        [isLoading]="isDeletingDealer()"
        [type]="'warning'"
        [size]="'medium'"
        [title]="deleteConfirmationTitle()"
        [message]="deleteConfirmationMessage()"
        [confirmText]="'Delete'"
        cancelText="Cancel"
        (confirm)="onConfirmDelete()"
        (cancel)="closeDeleteConfirmationModal()"
        (modalClose)="closeDeleteConfirmationModal()" />
}

@if (showStatusModal()) {
    <app-confirmation-modal
        [isVisible]="showStatusModal()"
        [showCancelButton]="false"
        [type]="statusModalType()"
        [size]="'medium'"
        [title]="statusModalTitle()"
        [message]="statusModalMessage()"
        [loopAnimation]="false"
        [confirmText]="'Close'"
        (confirm)="closeStatusModal()"
        (modalClose)="closeStatusModal()" />
}
